import i18n from "@/i18n";
import { ResourceAccess } from "@/services/security/types";

export const userMediaLibAclFields = [
    {
        key: "name",
        label: i18n.t("users.path"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "claim",
        label: i18n.t("users.permissions")
    },
    {
        key: "resourceAccesses",
        label: i18n.t("common.access"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
